/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Notification = {
    readonly id: number;
    /**
     * Notification type
     */
    readonly type: string;
    /**
     * Notification creation date
     */
    readonly created_date: string;
    /**
     * Notification acknowledgement date
     */
    readonly acknowledged_date: string;
    /**
     * Notification acknowledgement reaction
     */
    acknowledged_reaction?: string;
    /**
     * Notification acknowledgement reaction
     */
    readonly active: boolean;
    /**
     * Event id
     */
    readonly event_id: string;
    /**
     * Event object type
     */
    readonly object_type: string;
    /**
     * User that acknowledged notification
     */
    readonly acknowledged_by: number;
    /**
     * Ids of matched watchlists
     */
    readonly matched_watch_lists: Array<number>;
    readonly camera_group: number;
};
export const EmptyNotification: Notification = {
    id: 0,
    /**
     * Notification type
     */
    type: '',
    /**
     * Notification creation date
     */
    created_date: '',
    /**
     * Notification acknowledgement date
     */
    acknowledged_date: '',
    /**
     * Notification acknowledgement reaction
     */
    acknowledged_reaction: '',
    /**
     * Notification acknowledgement reaction
     */
    active: true,
    /**
     * Event id
     */
    event_id: '',
    /**
     * Event object type
     */
    object_type: '',
    /**
     * User that acknowledged notification
     */
    acknowledged_by: 0,
    /**
     * Ids of matched watchlists
     */
    matched_watch_lists: [],
    camera_group: 0,
};